import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip, faXmark } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import { formatBytes } from 'helpers/formatters/file_size_formats';

interface Props {
  name: string;
  size?: number;
  onRemove?: () => void;
}

export function AttachmentBadge({ name, size, onRemove }: Props) {
  const extension = name.includes('.') ? name.split('.').pop()?.toUpperCase() : null;
  const meta = [extension, size == null ? null : formatBytes(size)].filter(Boolean).join(' · ');

  return (
    <div className="ai-assistant-attachment d-inline-flex align-items-center gap-2 p-2 rounded">
      <FontAwesomeIcon className="text-muted" icon={faPaperclip} />
      <div className="d-flex flex-column">
        <span className="fw-semibold text-truncate" style={{ maxWidth: '12rem' }}>{name}</span>
        {meta && <span className="fs-xs text-muted">{meta}</span>}
      </div>
      {onRemove && (
        <Button
          aria-label={`Remove ${name}`}
          icon={faXmark}
          size="sm"
          variant="ghost"
          onClick={onRemove}
        />
      )}
    </div>
  );
}
